module.exports = __webpack_public_path__ + "static/media/isdoctorplan-gastro-1@2x.bae41b25.png";